(() => {
    const gallery = document.getElementById('quiz-gallery');
    const dotsEl = document.getElementById('quiz-dots');
    const optionsWrap = document.getElementById('quiz-options');
    const atcBtn = document.querySelector('[data-quiz-atc]');
    if (!atcBtn) return;

    // ---- view_item on load ----
    if (typeof QUIZ_BUYBOX_DL_ITEMS !== 'undefined' && QUIZ_BUYBOX_DL_ITEMS && QUIZ_BUYBOX_DL_ITEMS.length) {
        window.dataLayer = window.dataLayer || [];
        window.dataLayer.push({ event: 'view_item', ecommerce: { currency: QUIZ_BUYBOX_DL_ITEMS[0].currency, items: QUIZ_BUYBOX_DL_ITEMS } });
    }

    // ---- gallery ----
    function galleryGo(index) {
        const slides = gallery.querySelectorAll('.quiz-gallery__slide');
        const dots = dotsEl.querySelectorAll('.quiz-dot');
        slides.forEach((s, i) => s.classList.toggle('active', i === index));
        dots.forEach((d, i) => d.classList.toggle('active', i === index));
    }

    function rebuildGallery(images) {
        if (!gallery || !images || !images.length) return;
        const badge = gallery.querySelector('.quiz-guarantee');
        gallery.innerHTML = '';
        dotsEl.innerHTML = '';
        images.forEach((url, i) => {
            const img = document.createElement('img');
            img.src = url;
            img.className = 'quiz-gallery__slide' + (i === 0 ? ' active' : '');
            img.loading = i === 0 ? 'eager' : 'lazy';
            gallery.appendChild(img);
            if (images.length > 1) {
                const dot = document.createElement('button');
                dot.type = 'button';
                dot.className = 'quiz-dot' + (i === 0 ? ' active' : '');
                dot.setAttribute('aria-label', 'Image ' + (i + 1));
                dot.addEventListener('click', () => galleryGo(i));
                dotsEl.appendChild(dot);
            }
        });
        if (badge) gallery.appendChild(badge);
    }

    dotsEl.querySelectorAll('[data-quiz-gallery-dot]').forEach(dot => {
        dot.addEventListener('click', () => galleryGo(parseInt(dot.dataset.quizGalleryDot, 10)));
    });

    // ---- option select ----
    optionsWrap.querySelectorAll('[data-quiz-option]').forEach(row => {
        row.addEventListener('click', () => {
            optionsWrap.querySelectorAll('[data-quiz-option]').forEach(r => {
                r.classList.remove('selected');
                r.querySelector('.quiz-radio').classList.remove('on');
            });
            row.classList.add('selected');
            row.querySelector('.quiz-radio').classList.add('on');
            const key = row.dataset.productKey;
            const images = (typeof QUIZ_BUYBOX_IMAGES !== 'undefined' && QUIZ_BUYBOX_IMAGES[key]) ? QUIZ_BUYBOX_IMAGES[key] : null;
            if (images && images.length) rebuildGallery(images);
        });
    });

    // ---- cart drawer + badge ----
    function openCartDrawer() {
        if (window.Rebuy && window.Rebuy.SmartCart && typeof window.Rebuy.SmartCart.show === 'function') {
            window.Rebuy.SmartCart.show();
            return;
        }
        let attempts = 0;
        const wait = setInterval(() => {
            attempts++;
            if (window.Rebuy && window.Rebuy.SmartCart && typeof window.Rebuy.SmartCart.show === 'function') {
                clearInterval(wait);
                window.Rebuy.SmartCart.show();
            } else if (attempts >= 10) {
                clearInterval(wait);
                console.error('quiz-results-buybox: Rebuy.SmartCart was not available after waiting.');
            }
        }, 200);
    }

    function notifyCartUpdated() {
        window.dispatchEvent(new CustomEvent('campaign:cart-updated'));
    }

    function showAdded(btn, originalLabel, variantId) {
        btn.textContent = '\u2713 Added to Cart!';
        btn.classList.add('success');
        btn.disabled = false;
        try {
            const info = (typeof QUIZ_BUYBOX_DL_VARIANT_MAP !== 'undefined' && QUIZ_BUYBOX_DL_VARIANT_MAP) ? QUIZ_BUYBOX_DL_VARIANT_MAP[String(variantId)] : undefined;
            window.dataLayer = window.dataLayer || [];
            window.dataLayer.push({
                event: 'add_to_cart',
                ecommerce: {
                    currency: info ? info.currency : undefined,
                    items: [info ? { item_id: info.item_id, item_name: info.item_name, item_variant: info.item_variant, price: info.price, currency: info.currency, quantity: 1 } : { item_id: String(variantId), quantity: 1 }]
                }
            });
        } catch (e) {
            console.error('quiz-results-buybox dataLayer push error (non-blocking):', e);
        }
        openCartDrawer();
        notifyCartUpdated();
        setTimeout(() => {
            btn.textContent = originalLabel;
            btn.classList.remove('success');
            btn.disabled = false;
        }, 3500);
    }

    function showError(btn, message) {
        btn.textContent = message || 'Error, please try again';
        btn.disabled = false;
    }

    // Retry/verify: a slow network, a response-parsing hiccup, or a cart app
    // that intercepts and processes /cart/add.js asynchronously can all throw
    // even after the item was actually added — check the live cart before
    // reporting an error, retrying with increasing delay.
    function verifyCartThenReport(variantId, btn, originalLabel, fallbackMessage, attempt) {
        attempt = attempt || 0;
        const delays = [0, 500, 1200];
        fetch('/cart.js', { headers: { Accept: 'application/json' } })
            .then(r => r.json())
            .then(cart => {
                const inCart = cart && cart.items && cart.items.some(item => item.variant_id === variantId);
                if (inCart) {
                    showAdded(btn, originalLabel, variantId);
                } else if (attempt < delays.length - 1) {
                    setTimeout(() => verifyCartThenReport(variantId, btn, originalLabel, fallbackMessage, attempt + 1), delays[attempt + 1]);
                } else {
                    showError(btn, fallbackMessage);
                }
            })
            .catch(() => {
                if (attempt < delays.length - 1) {
                    setTimeout(() => verifyCartThenReport(variantId, btn, originalLabel, fallbackMessage, attempt + 1), delays[attempt + 1]);
                } else {
                    showError(btn, fallbackMessage);
                }
            });
    }

    atcBtn.addEventListener('click', () => {
        const selected = optionsWrap.querySelector('[data-quiz-option].selected');
        if (!selected) {
            document.getElementById('quiz-buybox').scrollIntoView({ behavior: 'smooth', block: 'start' });
            return;
        }
        const variantId = parseInt(selected.dataset.variantId, 10);
        if (!variantId) return;
        const originalLabel = atcBtn.textContent.trim();
        atcBtn.disabled = true;
        atcBtn.textContent = 'Adding\u2026';
        fetch('/cart/add.js', {
            method: 'POST',
            headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
            body: JSON.stringify({ id: variantId, quantity: 1 })
        })
            .then(r => r.json())
            .then(data => {
                if (data.status) {
                    verifyCartThenReport(variantId, atcBtn, originalLabel, data.description);
                } else {
                    showAdded(atcBtn, originalLabel, variantId);
                }
            })
            .catch(err => {
                console.error('quiz-results-buybox ATC error:', err);
                verifyCartThenReport(variantId, atcBtn, originalLabel, 'Error, please try again');
            });
    });
})();
